export default "__VITE_ASSET__hHHfZb2V__"